import Text from "components/Text";
import styled from "styled-components";

export const PricingWrapper = styled.div`
    background-color: #f9f9f9;
    margin: 0px 14px;
    width: 100%;
`;

export const PricingHeader = styled.div`
    width: 100%;
    padding: 34px 100px;
    padding-right: 100px;
    background-color: #fff;
    align-items: center !important;
    border-radius: 16px;
    margin-right: 14rem;

    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    @media only screen and (max-width: 767px) {
        flex-direction: column;
        gap: 2rem;
        padding: 100px;

        div:first-of-type {
            align-items: center;
            text-align: center;

            ${Text.Style} {
                text-align: center;
            }
        }
    }

    @media only screen and (max-width: 570px) {
        padding: 50px 100px;
    }
`;

export const DurationWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2rem;
`;

export const DiscountSection = styled.div`
    position: absolute;
    right: -64px;
    top: 16px;
    bottom: -65px;
    svg {
        width: 34px;
        height: 34px;
    }
`;

export const DiscountLabel = styled.div`
    background-color: #8868ea;
    padding: 6px 10px;
    border-radius: 8px;
    color: #fff;
`;

export const PricingContent = styled.div`
    display: flex;
    justify-content: space-evenly;
    gap: 10px;
    padding-top: 40px;
    padding-bottom: 40px;
    flex-wrap: wrap;
    background-color: white;
    margin-top: -21px;
    border-radius: 20px;
    align-items: center;
`;

export const PaymentContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    gap: 10px;
    padding-bottom: 40px;
    flex-wrap: wrap;
    background-color: white;
    margin-top: -11px;
    border-radius: 20px;
    align-items: center;
`;

export const CancelContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    gap: 10px;
    padding-top: 40px;
    padding-bottom: 40px;
    flex-wrap: wrap;
    background-color: white;
    margin-top: -21px;
    border-radius: 20px;
    align-items: center;
`;
